import React from 'react'
import {Icon, ListItem, ListItemText} from '@material-ui/core'
import {withStyles} from '@material-ui/core/styles/index'
import {NavLink, withRouter} from 'react-router-dom'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import * as Actions from 'store/actions'
import FuseNavBadge from '../FuseNavBadge'

const propTypes = {
  item: PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string,
    icon: PropTypes.string,
    url: PropTypes.string,
  }),
}

const defaultProps = {}

const styles = theme => ({
  root: {
    minHeight: 48,
    '&.active': {
      backgroundColor: '#663EE8',
      color: `${theme.palette.secondary.contrastText}!important`,
      pointerEvents: 'none',
      '& .list-item-text-primary': {
        color: 'inherit',
      },
      '& .list-item-icon': {
        color: 'inherit',
      },
    },
    '& .list-item-icon': {},
    '& .list-item-text': {},
    color: '#663EE8!important',
    textDecoration: 'none!important',
  },
})

function FuseNavVerticalItem({
  item,
  classes,
  nestedLevel,
  userRole,
  navbarCloseMobile,
}) {
  if (
    item.auth &&
    (!item.auth.includes(userRole) ||
      (userRole !== 'guest' &&
        item.auth.length === 1 &&
        item.auth.includes('guest')))
  ) {
    return null
  }

  const paddingValue = 40 + nestedLevel * 16
  const listItemPadding =
    nestedLevel > 0 ? `pl-${paddingValue > 80 ? 80 : paddingValue}` : 'pl-24'

  return (
    <ListItem
      button
      component={NavLink}
      to={item.url}
      activeClassName="active"
      className={classNames(classes.root, listItemPadding)}
      onClick={navbarCloseMobile}
      exact={item.exact}
    >
      {item.icon && (
        <Icon className="list-item-icon text-16 flex-no-shrink" color="action">
          {item.icon}
        </Icon>
      )}
      {item.image && (
        <img
          style={{
            width: '10%',
          }}
          alt=""
          src={item.image}
        />
      )}
      <ListItemText
        className="list-item-text"
        primary={item.title}
        classes={{primary: 'text-14 list-item-text-primary'}}
      />
      {item.badge && <FuseNavBadge badge={item.badge} />}
    </ListItem>
  )
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      navbarCloseMobile: Actions.navbarCloseMobile,
    },
    dispatch,
  )
}

function mapStateToProps({auth, fuse}) {
  return {
    userRole: auth.user.role,
  }
}

FuseNavVerticalItem.propTypes = propTypes
FuseNavVerticalItem.defaultProps = defaultProps

const NavVerticalItem = withStyles(styles, {withTheme: true})(
  withRouter(
    connect(
      mapStateToProps,
      mapDispatchToProps,
    )(FuseNavVerticalItem),
  ),
)

export default NavVerticalItem



// WEBPACK FOOTER //
// ./src/@fuse/components/FuseNavigation/vertical/FuseNavVerticalItem.js